module.exports = __webpack_public_path__ + "fc98c6674cdc98e5f3dcb4d72a1a18c1.jpg";